var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SelectGroup',{attrs:{"id":_vm.id,"label":_vm.label,"placeholder":_vm.placeholder,"isValid":_vm.isValid,"error":_vm.error,"options":_vm.getCountries,"selectedOption":_vm.getValue},on:{"handlerSelect":_vm.handleChangeCountry}})}
var staticRenderFns = []

export { render, staticRenderFns }